import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './ActionAI.css';

function ActionAI() {
  const [contentRef, contentVisible] = useScrollReveal();
  const [imagesRef, imagesVisible] = useScrollReveal();

  return (
    <section className="actionai section" id="actionai">
      <div className="container">
        <h2 className="section-title">
          <span >ActionAI</span>
        </h2>
        <p className="section-subtitle">
          Revolutionizing Reliable, Trustworthy AI for mission-critical use cases
        </p>

        <div ref={contentRef} className={`actionai__content reveal ${contentVisible ? 'visible' : ''}`}>
          <div className="actionai__text">
            <p>
              As CEO of <strong>ActionAI</strong>, Miriam leads an agentic AI company
              based in the Middle East that creates reliable AI solutions for enterprise
              workflows. From financial services to legal compliance, ActionAI is transforming
              how organizations handle mission-critical processes.
            </p>
            <p>
              The next era of AI does not include capability alone, but also trust. ActionAI is building the infrastructure to get there: AI systems that are accountable by design, where every output can be traced, explained, and stood behind.
            </p>
            <a
              href="https://actionai.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Visit ActionAI
            </a>
          </div>

          <div ref={imagesRef} className={`actionai__images reveal-children ${imagesVisible ? 'visible' : ''}`}>
            <img src="/images/action-section-image.png" alt="ActionAI" className="actionai__image" />
            <a
              href="https://www.axios.com/pro/enterprise-software-deals/2026/04/14/actionai-seed-ai-reliability"
              target="_blank"
              rel="noopener noreferrer"
              className="actionai__image-source"
            >
              Source: Axios Pro
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ActionAI;
